import React from "react";
import SocialAssistanceTable from "./SocialAssistanceTable/SocialAssistanceTable";

export default function SocialAssistanceCard(props) {
    const { social_assistance_data } = props
    const hasSource = Object.keys(social_assistance_data?.source || {}).length > 0;
    if (!hasSource) return null;
    return (
        <div style={{width: "100%", border: '1px solid #dedede', borderRadius: '8px', padding: '16px'}}>
            <p style={{fontSize: "14px", fontWeight: "bold", margin: "0 0 16px 0", padding: 0, color: '#0b1f82'}}>
                Auxílios Sociais - Informações encontradas
            </p>
            <SocialAssistanceTable social_assistance_data={social_assistance_data.source} />
        </div>
    )
}
